import Modal, { ModalVariants } from "@deloitte-omnia/core-fe-mfe/Modal";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";

const SessionTimeout = ({ msalInstance }) => {
  const [timeoutWarning, setTimeoutWarning] = useState(false);
  const [countdown, setCountdown] = useState(60); // 1-minute countdown
  // eslint-disable-next-line no-unused-vars
  const [idleTime, setIdleTime] = useState(0);

  const [showModal, setShowModal] = useState(false);

  const resetIdleTime = useCallback(() => {
    setIdleTime(0);
    if (timeoutWarning) {
      setTimeoutWarning(false);
      setCountdown(60);
    }
  }, [timeoutWarning]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIdleTime((prevIdleTime) => {
        if (prevIdleTime >= 15 * 60) {
          // 15 minutes
          setTimeoutWarning(true);
          setShowModal(true);
        }
        if (prevIdleTime >= 16 * 60) {
          // 16 minutes
          msalInstance.logoutRedirect();
          setShowModal(false);
        }
        return prevIdleTime + 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [msalInstance]);

  useEffect(() => {
    if (timeoutWarning) {
      const countdownInterval = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown <= 1) {
            msalInstance.logoutRedirect();
          }
          return prevCountdown - 1;
        });
      }, 1000);

      return () => clearInterval(countdownInterval);
    }
  }, [timeoutWarning, msalInstance]);

  useEffect(() => {
    if (!timeoutWarning) {
      const events = ["click", "mousemove", "keydown", "scroll", "touchstart"];
      const resetTimeout = () => resetIdleTime();

      events.forEach((event) => window.addEventListener(event, resetTimeout));
      return () =>
        events.forEach((event) =>
          window.removeEventListener(event, resetTimeout)
        );
    }
  }, [resetIdleTime]);

  const handleExtendSession = () => {
    setShowModal(false);
    msalInstance
      .acquireTokenSilent({
        account: msalInstance.getAllAccounts()[0],
        scopes: [window.environment.REACT_APP_API_SCOPE, "User.Read"],
      })
      .then(() => {
        resetIdleTime();
      })
      .catch(() => {
        msalInstance.loginPopup();
      });
  };

  return (
    <React.Fragment>
      <div>
        <Modal
          show={showModal}
          variant={ModalVariants.warning}
          title="Session Timeout"
          onButtonClick={handleExtendSession}
          buttonText="Keep Working"
          onDismissClick={() => msalInstance.logoutRedirect()}
          dismissButtonText="Logout"
        >
          <p>
            Your session will expire in{" "}
            <span className="countdown">{countdown}</span> seconds.
          </p>
        </Modal>
      </div>
    </React.Fragment>
  );
};

SessionTimeout.propTypes = {
  msalInstance: PropTypes.shape({
    logoutRedirect: PropTypes.func.isRequired,
    acquireTokenSilent: PropTypes.func.isRequired,
    getAllAccounts: PropTypes.func.isRequired,
    loginPopup: PropTypes.func.isRequired,
  }).isRequired,
};

export default SessionTimeout;
